import { FormikProps, getIn } from 'formik'
import React from 'react'
import { ErrorLabel, Label, TextEditor } from '..'
import { UploadImagemEditor } from '../Input/TextEditor'
import { FontSize } from '../../../_metronic/helpers'

interface FormTextEditorProps {
  label: string
  name: string
  formik: FormikProps<any>
  isDisabled?: boolean
  isRequired?: boolean
  className?: string
  height?: number
  placeholder?: string
  infoText?: string
  labelSize?: FontSize
  highlight?: boolean
  /** Só os formulários que aceitam imagem no HTML passam isto; os demais ficam sem o botão. */
  onUploadImage?: UploadImagemEditor
}

export const FormTextEditor: React.FC<FormTextEditorProps> = ({
  label,
  name,
  formik,
  isDisabled = false,
  isRequired = false,
  className = '',
  height = 300,
  placeholder,
  labelSize,
  infoText,
  highlight,
  onUploadImage,
}) => {
  const errorMessage = getIn(formik.errors, name, null)
  const touched = getIn(formik.touched, name, '')

  const handleChange = (content: string) => {
    formik.setFieldValue(name, content)
  }

  return (
    <div className={`row ${className}`}>
      <Label
        className='mb-2'
        isRequired={isRequired}
        size={labelSize}
        infoText={infoText}
        highlight={highlight}
      >
        {label}
      </Label>
      <TextEditor
        value={formik.values[name] || ''}
        onChange={handleChange}
        disabled={formik.isSubmitting || isDisabled}
        height={height}
        placeholder={placeholder}
        onUploadImage={onUploadImage}
      />
      {touched && errorMessage && <ErrorLabel>{errorMessage}</ErrorLabel>}
    </div>
  )
}
